export default __webpack_public_path__ + "static/media/rare.505cc476.svg";